import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';

import { Badge as BadgeType } from '@web/conversations/Reactions/types/Badge';

import { Badge, Counter } from './reactionBadges.styles';

type Props = {
  badges: BadgeType[];
  handleClick: (reaction: string, isSelected: boolean) => void;
  isReadonly?: boolean;
};

export const ReactionBadges = ({ badges, handleClick, isReadonly }: Props) => (
  <>
    {badges.map((badge) => (
      <SmartTooltip key={badge.emoji} content={badge.label} type="light">
        <Badge
          isReadonly={isReadonly}
          isSelected={badge.isSelected}
          onClick={() => !isReadonly && handleClick(badge.emoji, badge.isSelected)}>
          {badge.emoji}
          <Counter>{badge.counter}</Counter>
        </Badge>
      </SmartTooltip>
    ))}
  </>
);
